import { ITranslationService } from "angular-i18next";
import { setupI18Next } from "./setupI18Next";

export const appInit = (i18next: ITranslationService) => () => setupI18Next(i18next);
